import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Locale } from '../components/language-switcher/language.interface';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private translate = inject(TranslateService);
  private currentLanguage$ = new BehaviorSubject<Locale>(this.getInitialLanguage());

  constructor() {
    this.initializeTranslation();
  }

  private initializeTranslation(): void {
    const language = this.getInitialLanguage();
    this.translate.setFallbackLang(Locale.english);
    this.translate.use(language);
    this.currentLanguage$.next(language);
  }

  private getInitialLanguage(): Locale {
    // Sprawdzenie localStorage
    if (typeof localStorage !== 'undefined') {
      const stored = localStorage.getItem('language');
      if (stored === Locale.polish || stored === Locale.english) {
        return stored;
      }
    }

    // Sprawdzenie preferencji przeglądarki
    const browserLang = navigator.language.toLowerCase();
    if (browserLang.startsWith('pl')) {
      return Locale.polish;
    }

    // Domyślnie angielski
    return Locale.english;
  }

  setLanguage(language: Locale): void {
    this.translate.use(language);
    localStorage.setItem('language', language);
    this.currentLanguage$.next(language);
  }

  getCurrentLanguage(): Locale {
    return this.currentLanguage$.value;
  }

  getCurrentLanguage$(): Observable<string> {
    return this.currentLanguage$.asObservable();
  }
}
